import { useEffect } from 'react';
import {
  NarvarEventTypes,
  NarvarEventComponents,
  useAnalyticsPost,
} from '../../../../../hooks/Analytics';
import { Shipment } from '../../../../../../../__generated__/loma';
import useEddTimeRange from '../../../../features/EddPanelNew/hooks/useEddTimeRange';

function useLogEdd(shipment: Shipment | null, featureName?: string) {
  const logEvent = useAnalyticsPost();

  const formattedEddTimeRange = useEddTimeRange();

  useEffect(() => {
    if (!shipment) return;

    const {
      type,
      status,
      displayDate,
      displayDateRange,
      trackingNumber,
      carrier,
      eddTimeRange,
    } = shipment;

    if (type === 'SHIPMENT' && status === 'DELIVERED') return;

    const edd =
      displayDateRange?.end ?? displayDateRange?.begin ?? displayDate ?? '';

    if (!edd) return;

    const clientDate = new Date();
    const eddDate = new Date(edd);

    let isValidDate = true;

    // new Date(edd) will return 'Invalid Date' if the date isn't valid,
    // but in case that ever changes, we can do a more trusted validation.
    // toISOString() will always throw a RangeError if not valid
    try {
      eddDate.toISOString();
    } catch (err) {
      console.error('Error validating EDD date', err);
      isValidDate = false;
    }

    const eddNotPossible = isValidDate ? clientDate > eddDate : false;

    if (isValidDate) {
      logEvent({
        displayedEddBegin: edd,
        displayedEddEnd: displayDateRange?.end,
        eventCarrierMoniker: carrier,
        eventComponent: NarvarEventComponents.NTH_BLOCK_EDD,
        eventFeature: NarvarEventComponents.NTH_BLOCK_EDD,
        eventTrackStatus: status,
        eventTrackingNumber: trackingNumber,
        eventType: eddNotPossible
          ? NarvarEventTypes.TRACK_QUALITY
          : NarvarEventTypes.COMPONENT_RENDER,
        feature: featureName,
        pageCarrierService: carrier,
        pageComponent: NarvarEventComponents.NTH_BLOCK_EDD,
        pageHasEdd: edd.length > 0,
        trackEddBegin: edd,
        trackEddEnd: displayDateRange?.end,
        eddTimeRangeBegin: eddTimeRange?.[0],
        eddTimeRangeEnd: eddTimeRange?.[1],
        eddDisplayedTimeRange: formattedEddTimeRange?.join(' - '),
      });
    }
  }, [featureName, logEvent, shipment]);
}

export { useLogEdd };
